<template>
  <div>
    <!-- Adviseurs omgeving; Doelen scherm -->
    <div v-if="role == 2">
      <div id="firstMenubar" class="row roundedtop menubar">
        <div class="title">Offerte maken</div>
        <a
          v-if="style == 'db'"
          href="https://www.doelbeleggen.nl/agenda/atp"
          target="_blank"
          class="button"
          style="float:right;"
        >
          <awesomeIcon icon="phone-alt"/> <span class="mobile-hidden">Plan een belafspraak in</span>
        </a>
      </div>
      <div class="card inset-small marginbottom roundedBottom" v-if="role == 2">
        <h3>Samen Doelbeleggen - dé portal voor adviserend Nederland</h3>
        <p>
          Op deze pagina kunt u berekeningen maken of offertes opstellen voor uw klant. De eerste
          stap is het selecteren van de doelstelling van uw klant. Na het selecteren van de
          doelstelling kunt u de doelgegevens van uw klant invullen. Op basis van deze doelgegevens
          wordt er een offerte opgesteld of een berekening gemaakt.
          <br /><br />
          Na het opstellen van een offerte of berekening kunt u rechtsonder kiezen voor
          ‘Start Vragenlijst’. U kunt nu de persoonlijke financiële situatie van uw klant indien
          gewenst alvast invullen. Wilt u liever eerst alleen de offerte versturen? Onder het kopje
          ‘Risico’ kunt u nu het gewenste risicoprofiel van uw klant selecteren, dit wordt
          overgenomen in de offerte.
          <br /><br />
          Om de offerte of berekening met uw klant te delen gaat u naar het kopje ‘Klantkoppeling’.
          Hier kunt u het e-mailadres van uw klant invullen om de offerte toe te sturen. Tevens kunt
          u aangeven of u kosten wilt incasseren via de beleggingsrekening.
          <br /><br />
          Na het koppelen ontvangt uw klant een gepersonaliseerde mail namens u. Het verdere verloop
          van de aanvraag kunt u uiteraard real-time blijven volgen.
        </p>
      </div>
    </div>
    <div class="flex-container" v-if="!lock">
      <div class="menubar flex-100">
        <span class="title">Wat is de doelstelling van uw klant?</span>
      </div>

      <div
        class="flex-33 card option"
        @click="newIntake('pensioen-box-1')"
        style="height: 200px;"
      >
        <h2>Lijfrente opbouwen (box{{'\xa0'}}1)</h2>
        <p>
          Dit is voor de klant die gaat starten met het opbouwen middels jaar- en
          reserveringsruimte.
        </p>
      </div>

      <div
        class="flex-33 card option"
        @click="newIntake('pensioen-box-1')"
        style="height: 200px;"
      >
        <h2>Lijfrente uitstellen (box{{'\xa0'}}1)</h2>
        <p>
          Dit is voor de klant waar een kapitaal vrijkomt, maar die nog wil wachten met het
          uitkeren. In de tussentijd kan er al belegd worden.
        </p>
      </div>

      <div
        class="flex-33 card option"
        @click="newIntake('levensonderhoud-box-1')"
        style="height: 200px;"
      >
        <h2>Lijfrente uitkeren (box{{'\xa0'}}1)</h2>
        <p>
          Dit is voor de klant die een kapitaal beschikbaar heeft en direct wil starten met
          uitkeren.
        </p>
      </div>

      <div
        class="flex-33 card option"
        @click="newIntake('nettolijfrente-opbouwend')"
        style="height: 200px;"
      >
        <h2>
          Netto lijfrente</h2>
        <p>
          Dit is voor de klant die naast de jaarruimte nog meer wil opbouwen (voor inkomens
          boven de &euro; 115.000).
        </p>
      </div>

      <div
        class="flex-33 card option"
        @click="newIntake('goudenhanddruk-opbouwend')"
        style="height: 200px;"
      >
        <h2>Gouden handdruk uitstellen</h2>
        <p>
          Dit is voor de klant met vrij GH-kapitaal, maar die nog wil wachten.
          In de tussentijd kan er al belegd worden.
        </p>
      </div>

      <div
        class="flex-33 card option"
        @click="newIntake('goudenhanddruk-uitkerend')"
        style="height: 200px;"
      >
        <h2>Gouden handdruk uitkeren</h2>
        <p>
          Dit is voor de klant die een GH kapitaal beschikbaar heeft en direct wil starten met
          uitkeren.
        </p>
      </div>

      <div
        class="flex-33 card option"
        @click="newIntake('vermogensopbouw')"
        style="height: 200px;"
      >
        <h2>Privé beleggingsrekening</h2>
      </div>

      <div
        class="flex-33 card option"
        @click="newIntake('zakelijke-vermogensopbouw')"
        style="height: 200px;"
      >
        <h2>Zakelijke beleggingsrekening</h2>
      </div>

      <div
        class="flex-33 card option"
        @click="newIntake('studie-kinderen')"
        style="height: 200px;"
      >
        <h2>Beleggingsrekening voor kinderen</h2>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'AtpGoals',
  data() {
    return {
      style: process.env.VUE_APP_STYLE,
      lock: false,
    };
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
  },
  methods: {
    newIntake(goal) {
      if (!this.lock) {
        this.lock = true;
        this.sdk.createIntake(
          (response) => {
            if (response.status === 200) {
              window.location.href = `?intake=${response.data.intake}`;
            }
            this.lock = false;
          },
          goal,
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-container {
column-gap: 20px;
row-gap: 20px;
@media #{$mobile} {
  row-gap: 10px;
  padding: 43px 10px 10px;
}
}
@media #{$mobile} {
  #firstMenubar {
    top: 91px !important;
  }
}
.button.horizontal {
margin: 10px;
&:first-of-type {
    margin-left: 0;
}
&:last-of-type {
    margin-right: 0;
}
}
</style>
